import Vue from "vue";
import i18n from "../../../i18n";

export default {
  async createTrencher({ commit }, payload) {
    return Vue.axios.post(Vue.$url("trencher"), payload).then((rsp) => {
      Vue.$log.debug("trencher created and saved under", rsp.id);
      commit("mShowInfoMessage", i18n.t("common.saved", { 0: "Trencher", 1: payload.description }), { root: true });
    });
  },

  async fetchTrenchers({ commit }, { pId, vId, pvId = null, active = -1 }) {
    Vue.$log.debug("loading trenchers for", pId, vId, active);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "") + "&pvId=" + (pvId || "") + "&isDel=" + (active == -1 ? "" : !active);
    return Vue.axios.get(Vue.$url("trencher" + query)).then((rsp) => commit("SET_TRENCHERS", rsp.data));
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug("loading trencher next code for", pId, vId);
    let query = "?pId=" + (pId || "") + "&vId=" + (vId || "");
    return Vue.axios.get(Vue.$url("trencher/max-code" + query)).then((rsp) => {
      commit("SET_NEXT_SEQ_CODE", rsp.data);
      return rsp.data;
    });
  },

  async deleteTrencher({ commit }, payload) {
    Vue.$log.debug("trying to delete Trencher", payload.id);
    return Vue.axios.delete(Vue.$url("trencher/" + payload.id)).then(() => {
      commit("mShowInfoMessage", i18n.t("common.lockupdate", { 0: payload.description }), { root: true });
    });
  },

  async updateTrencher({ commit }, payload) {
    return Vue.axios.put(Vue.$url("trencher/" + payload.id), payload).then(() => {
      commit("mShowInfoMessage", i18n.t("common.updated", { 0: "Trencher", 1: payload.description }), { root: true });
    });
  },

  async updateTrencherList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("pvId", payload.pvId);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`trencher/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.upload"), { root: true });
        return rsp.data;
      });
  },
};
